<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        
        <v-row class="py-1 px-5">
          <v-col cols="12" md="4" ACTIONPANNEL>
            <v-row>
              <v-col cols="12" ACCOUNTTOPINFO>
                <v-card>
                  <v-card-text>
                    <v-row>
                      <v-col cols="4" class="text-center">
                        <div class="mb-2">
                          <v-avatar
                            size="30"
                            v-if="user && user.name"
                            color="primary white--text"
                            style="font-size:12px;"
                          >
                            {{user.name.slice(0,1)}}
                          </v-avatar>
                        </div>
                        <div>{{user.name}}</div>
                      </v-col>
                      <v-col cols="8" class="text-left">
                        <v-chip color="primary" :class="`${arabic?'arFont':'enFont'} white--text`">
                          {{ i18n["new_account"] }}
                        </v-chip>
                      </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row>
                      <v-col cols="6" :class="`${arabic?'arFont':'enFont'}`">
                        {{ i18n['affiliate_code'] }}
                      </v-col>
                      <v-col cols="6" v-if="user.account && user.account.affiliate_code">
                        {{user.account.affiliate_code}}
                      </v-col>
                      <v-col cols="12">
                        <v-btn color="secondary" disabled block small :class="`${arabic?'arFont':'enFont'}`">{{ i18n['copy_affiliate_link'] }}</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" ACCOUNTTOPINFO>
                <v-card>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`">
                        <v-btn block color="success" large @click="goTo('/import')" :class="`${arabic?'arFont':'enFont'}`">
                          {{ i18n["import_orders"] }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" ACCOUNTSELECTOR>
                <v-card>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" class="text-center">
                        <v-list>
                          <v-list-item-group v-model="selectedPanel">
                            <v-list-item
                              v-for="(item, i) in subitems"
                              :key="i"
                              :value="item.value"
                            >
                              <v-list-item-icon>
                                <v-icon v-text="item.icon"></v-icon>
                              </v-list-item-icon>
                              <v-list-item-content @click="showPannel(item.value)" :class="`${arabic?'arFont':'enFont'}`">
                                <v-list-item-title>{{ i18n[item.text] }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="8" LeadsPannel>
            <v-row>
              <v-col cols="12" LEADSPANEL>
                <v-card>
                  <v-card-text class="py-0">
                    <v-row class="align-center">
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLE>
                            <v-icon size="40" color="secondary">shopping_cart</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic?'arFont':'enFont'} black--text`">
                              {{ i18n["your_orders"] }}
                            </div>
                            <div :class="`${arabic?'arFont':'enFont'} grey--text`">
                              {{ i18n['all_your_order_details'] }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class=" py-0">
                        <v-row class="align-center">
                          <v-col cols="12" class="text-center py-0" FILTER>
                            <v-text-field
                              :label="i18n['search_by_phone_name_document_number']"
                              outlined
                              :loading="loading"
                              prepend-icon="search"
                              :class="`${arabic?'arFont':'enFont'}`"
                              hide-details
                              v-model="search"
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-1" FILTER>
                            <v-menu
                              v-model="menu1"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="fromDate"
                                  :label="i18n['from_date']"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  :loading="loading"
                                  outlined
                                  hide-details
                                  dense
                                  :class="`${arabic?'arFont':'enFont'}`"

                                  @change="filterLeads()"
                                  clearable
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="fromDate"
                                @change="filterLeads()"
                                @input="menu1 = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-1" FILTER>
                            <v-menu
                              v-model="menu2"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="toDate"
                                  :label="i18n['to_date']"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  :loading="loading"
                                  :class="`${arabic?'arFont':'enFont'}`"
                                  hide-details
                                  outlined
                                  @change="filterLeads()"
                                  dense
                                  clearable
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="toDate"
                                @change="filterLeads()"
                                @input="menu2 = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center py-1" FILTER>
                            <v-autocomplete
                              :items="resource.statuses"
                              v-model="selectedStatus"
                              :label="i18n.status"
                              autocomplete="disabled"
                              outlined
                              hide-details
                              clearable
                              dense
                              :loading="loading"
                              prepend-icon="task_alt"
                              @change="filterLeads()"
                              item-value="id"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              <template v-slot:selection="{ attr, on, item, selected }">
                                <span
                                  v-bind="attr"
                                  :input-value="selected"
                                  v-on="on"
                                  :class="`${arabic?'arFont':'enFont'}`"
                                >
                                  <v-chip x-small>{{statuses_obj[item] ? statuses_obj[item][language] : ''}}</v-chip>
                                </span>
                              </template>
                              <template v-slot:item="{ item }">
                                <span
                                  :class="`${arabic?'arFont':'enFont'}`"
                                >
                                  {{statuses_obj[item] ? statuses_obj[item][language] : item}}
                                </span>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          
                          <v-col cols="12" md="6" class="text-center py-0" BTN>
                            <v-btn 
                              color="secondary" 
                              block 
                              :loading="loading"
                              :class="`${arabic?'arFont':'enFont'}`" 
                              @click="loadResource()">
                              {{ i18n['search'] }}
                              <v-icon right size="15">search</v-icon>
                            </v-btn>
                          </v-col>
                          <v-col cols="12" md="6" class="text-center py-0" BTN>
                            <v-btn 
                              color="success" 
                              block 
                              :loading="loading"
                              :class="`${arabic?'arFont':'enFont'}`" 
                              @click="exportResource()">
                              {{ i18n['export_orders'] }}
                              <v-icon right size="15">file_download</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="2" :class="`${arabic?'arFont':'enFont'} text-center pa-2`">
                        <span v-if="resource.data" :class="`${arabic?'arFont':'enFont'}`"> {{ i18n['orders'] }} ({{ resource.total }})</span>
                      </v-col>
                      <v-col cols="12" md="8" class="text-center pa-2">
                        <Paging 
                          :resourceSettings="resourceSettings" 
                          :resource="resource"
                          @loadResource="loadResource"
                          @pageByNumber="pageByNumber"
                        />
                      </v-col>
                      <v-col cols="12" md="2" class="text-center pa-2">
                        <div 
                          v-if="resource.time" 
                          style="font-size:11px;direction:ltr!important;" 
                          :class="`${arabic?'arFont':'enFont'}`">
                          {{(resource.time * 1000 ).toFixed(0)}}  ms 
                        </div>
                        <v-progress-circular v-if="loading" color="primary" :indeterminate="true"></v-progress-circular>
                      </v-col>
                      <v-col cols="12">
                        <LeadsList :leads="resource.data" @clipboardSuccessHandler="clipboardSuccessHandler" @clipboardErrorHandler="clipboardErrorHandler" />
                      </v-col>
                      <Edit @snackbarNotification="getSnack" @loadResource="loadResource" />
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Paging from '@/components/Paging'
import LeadsList from '@/components/LeadsList'
import json2csv from 'json2csv'
import Edit from '@/components/Edit'

export default {
  components: {LeadsList, Paging, Edit},
  data() {
    return {
      loading:false,
      dialog:false,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[
        
      ],
      resourceSettings:{
        resourceName:null,
        search:false,
        create:false,
        pagination:true,
      },
      newResource:{},
      editing:false,
      deleting:false,
      firstPanel:true,
      secondPanel:false,
      thirdPanel:false,
      selectedPanel:'firstPanel',
      subitems:[
        {
          text:'add_new_order',
          icon:'add_shopping_cart',
          value:'firstPanel'
        },
        // {
        //   text:'التوصل مع الدعم',
        //   icon:'support_agent',
        //   value:'secondPanel'
        // },
      ],
      menu1:false,
      fromDate:null,
      menu2:false,
      toDate:null,
      statuses:[],
      selectedStatus:null,
    }
  },
  methods: {
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    getSnack(text, color){
      this.$emit('snackbarNotification', text, color)
    },
    clipboardSuccessHandler (){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler () {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path, page:`?page=${n}` + this.buildFilter()})
        } else {
          this.resource = await this.$store.dispatch('postResource', {resource:this.$route.path + `/search?page=${n}`, value:this.search})
          this.$emit('snackbarNotification', `${this.i18n["number_of_orders_found"]}: ${this.resource.data.length}`, 'success')
        }
        this.loading = false
      })
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    buildFilter(){
      let filter = ``
      if(this.fromDate && this.toDate) {
        filter += `&filter[from]=${this.fromDate}&filter[to]=${this.toDate}`
      }
      if(this.selectedStatus) {
        filter += `&filter[status]=${this.selectedStatus}`
      }
      
      return filter
    },
    async filterLeads(){
      // console.log('filterLeads')
      await this.loadResource()
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path + '?' + this.buildFilter()})
          // console.log(this.resource)
        } else {
          // console.log('search', this.search)
          this.resource = await this.$store.dispatch('postResource', {resource:this.$route.path + `-search?` + this.buildFilter(), value:{search:this.search}})
        }
        this.loading = false
        res()
      })
    },
    async exportResource(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let exp = await this.$store.dispatch('getResource', {resource:'/leads-export' + '?' + this.buildFilter()})
        this.exportSimpleData(exp, 'leads')
        this.loading = false
        res()
      })
    },
    exportSimpleData(data, name){
      let a = json2csv.parse(data)
      // console.log(a)
      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri =  csvContent + encodeURIComponent(a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      let n = name ? name : 'failed_export'
      link.setAttribute("download", `${n}_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },
    showPannel(v){
      this[v] = true
      let all = this.subitems.map(x=>x.value)
      all.filter(x=>x!=v).forEach(x=>this[x] = false)
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.i18n[this.$route.path.replace('/', '')]
    }
  },
  computed:{
    statuses_obj(){
      
      return this.$store.state.statuses_obj
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    console.log(Object.keys(this.$store.state.statuses_obj))
    this.setResourceName()
    this.loadResource()
    
  },
}
</script>

<style>

</style>